import * as React from "react";

import { WarrantyModal, WhatIsIncludedModal } from "../modals";

export const EndOfTenancyModals = () => (
  <React.Fragment>
    <WhatIsIncludedModal />
    <WarrantyModal />
  </React.Fragment>
);
